"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Calendar = void 0;
var _react = _interopRequireDefault(require("react"));
var _box = require("@oneloop/box");
var _daygrid = _interopRequireDefault(require("@fullcalendar/daygrid"));
var _timegrid = _interopRequireDefault(require("@fullcalendar/timegrid"));
var _interaction = _interopRequireDefault(require("@fullcalendar/interaction"));
var _rrule = _interopRequireDefault(require("@fullcalendar/rrule"));
var _react2 = _interopRequireDefault(require("@fullcalendar/react"));
require("../styles/calendar.css");
var _esUs = _interopRequireDefault(require("@fullcalendar/core/locales/es-us"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var date = new Date();
var CalendarOptions = {
  days: {
    slotLabelFormat: {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      meridiem: false
    },
    eventTimeFormat: {
      hour: '2-digit',
      minute: '2-digit',
      meridiem: false
    },
    plugins: [_interaction["default"], _timegrid["default"], _rrule["default"]],
    initialView: 'timeGridDay',
    headerToolbar: {
      start: 'prev',
      center: 'title',
      end: 'next'
    },
    dayHeaders: false,
    stickyFooterScrollbar: false
  },
  fullCalendar: {
    plugins: [_daygrid["default"], _rrule["default"], _timegrid["default"]],
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay'
    },
    initialView: 'dayGridMonth'
  }
};
var Calendar = exports.Calendar = function Calendar(_ref) {
  var variant = _ref.variant,
    events = _ref.events,
    initialDate = _ref.initialDate,
    scrollTime = _ref.scrollTime,
    height = _ref.height,
    moreOptions = _ref.moreOptions;
  var options = _objectSpread(_objectSpread(_objectSpread({}, CalendarOptions[variant]), moreOptions), {}, {
    events: events || [],
    initialDate: initialDate,
    scrollTime: scrollTime || "".concat(date.getHours() - 2, ":00:00"),
    height: height
  });
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    id: variant
  }, /*#__PURE__*/_react["default"].createElement(_react2["default"], _extends({
    locale: _esUs["default"]
  }, options)));
};